import { gql } from 'react-apollo';

export const updateUser = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        type
        email
        name
        photo {
          small
        }
        department
        phone
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/profile/mutations/updateUser.js